import { render, staticRenderFns } from "./delivery-zone-component.vue?vue&type=template&id=3a03522f&scoped=true"
import script from "./delivery-zone-component.vue?vue&type=script&lang=js"
export * from "./delivery-zone-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a03522f",
  null
  
)

export default component.exports